import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";
import { useWalletBonus } from "../hooks";
import { selectModalWalletBonus } from "../../../redux";
import { AdminMenuLayout, ModalWalletBonus } from "../../../shared/components";
import { WrapperCardWalletBonus } from "./styled";
import { TableWalletBonus } from "./TableWalletBonus";

export const WalletBonus = () => {
  const modalWalletBonus = useSelector(selectModalWalletBonus);
  const {
    isUpdateWalletBonus,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalWalletBonusState,
  } = useWalletBonus();

  return (
    <AdminMenuLayout pageDescription="WalletBonus" title="WalletBonus">
      <WrapperCardWalletBonus>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalWalletBonusState}
            >
              Agregar bonus
            </Button>
          </Col>
        </Row>
        <TableWalletBonus />
        {modalWalletBonus && isUpdateWalletBonus && (
          <FormProvider {...formMethodsUpdate}>
            <ModalWalletBonus />
          </FormProvider>
        )}
        {modalWalletBonus && !isUpdateWalletBonus && (
          <FormProvider {...formMethodsCreate}>
            <ModalWalletBonus />
          </FormProvider>
        )}
      </WrapperCardWalletBonus>
    </AdminMenuLayout>
  );
};
